// Senior French Unit Tests - Years 11-13
// Assessment materials for French as a Foreign Language

export const year11FrenchUnitTests = {
  year: 11,
  subject: "French as a Foreign Language",
  strands: {
    strand1: {
      name: "Expression orale",
      tests: [
        {
          id: "ffl1-11-test",
          title: "Test d'expression orale",
          duration: "30 minutes",
          totalMarks: 25,
          questions: [
            {
              id: 1,
              question: "Traduisez en français:\n(a) In my opinion\n(b) I agree\n(c) First\n(d) Finally\n(e) I think that",
              marks: 5,
              answer: "(a) À mon avis\n(b) Je suis d'accord\n(c) D'abord\n(d) Finalement / Enfin\n(e) Je pense que"
            },
            {
              id: 2,
              question: "Complétez avec l'expression correcte:\n\"____ , je vais vous parler de la pollution. ____ , c'est un problème grave. ____ , nous devons agir.\"",
              marks: 3,
              answer: "Premièrement / D'abord, je vais vous parler de la pollution. En effet / Car, c'est un problème grave. Donc / Ainsi, nous devons agir."
            },
            {
              id: 3,
              question: "Écrivez cinq phrases pour raconter ce que vous avez fait hier. Utilisez le passé composé.",
              marks: 5,
              answer: "Exemple: Hier, je me suis levé(e) à 7 heures. J'ai pris mon petit-déjeuner. Je suis allé(e) à l'école. J'ai étudié le français. Je suis rentré(e) à la maison."
            },
            {
              id: 4,
              question: "Donnez votre opinion sur cette question: 'Les téléphones portables à l'école - pour ou contre?' Écrivez 3-4 phrases.",
              marks: 6,
              answer: "Réponse modèle: À mon avis, les téléphones portables devraient être interdits en classe. D'abord, ils distraient les élèves. Ensuite, ils peuvent être utilisés pour tricher. Cependant, ils peuvent être utiles pour les recherches."
            },
            {
              id: 5,
              question: "Comment dit-on 'Je ne suis pas d'accord' en français? Donnez aussi deux autres expressions pour exprimer le désaccord.",
              marks: 3,
              answer: "Je ne suis pas d'accord. Autres: Au contraire / Ce n'est pas vrai / Je m'oppose à cette idée / Je conteste cette opinion"
            }
          ]
        }
      ]
    },
    strand2: {
      name: "Lire et répondre",
      tests: [
        {
          id: "ffl2-11-test",
          title: "Test de compréhension écrite",
          duration: "45 minutes",
          totalMarks: 30,
          questions: [
            {
              id: 1,
              question: "Lisez le texte et répondez:\n\n\"Marie habite à Port-Vila. Elle est étudiante et elle aime beaucoup lire. Le week-end, elle va souvent à la plage avec ses amis. Elle rêve de visiter la France un jour.\"\n\n(a) Où habite Marie?\n(b) Qu'est-ce qu'elle aime faire?\n(c) Que fait-elle le week-end?\n(d) Quel est son rêve?",
              marks: 4,
              answer: "(a) Marie habite à Port-Vila.\n(b) Elle aime beaucoup lire.\n(c) Elle va à la plage avec ses amis.\n(d) Elle rêve de visiter la France."
            },
            {
              id: 2,
              question: "Associez les types de textes avec leurs caractéristiques:\n1. Texte narratif\n2. Texte descriptif\n3. Texte argumentatif\n\n(a) Donne des opinions et des arguments\n(b) Raconte une histoire avec des personnages\n(c) Décrit une personne, un lieu ou une chose",
              marks: 3,
              answer: "1-b (Texte narratif raconte une histoire)\n2-c (Texte descriptif décrit)\n3-a (Texte argumentatif donne des opinions)"
            },
            {
              id: 3,
              question: "Quels sont les éléments à identifier avant de lire un texte? Nommez-en quatre.",
              marks: 4,
              answer: "Le titre, les images/illustrations, l'auteur, la source, les sous-titres, la date, le type de texte"
            },
            {
              id: 4,
              question: "Dans le texte suivant, identifiez: le personnage principal, le lieu, et l'action:\n\n\"Thomas se promène dans le jardin. Il regarde les fleurs et écoute les oiseaux chanter.\"",
              marks: 3,
              answer: "Personnage principal: Thomas\nLieu: le jardin\nAction: Il se promène, regarde les fleurs, écoute les oiseaux"
            },
            {
              id: 5,
              question: "Expliquez en français ce que signifie 'lire entre les lignes'.",
              marks: 3,
              answer: "Cela signifie comprendre ce qui n'est pas dit directement, le sens implicite ou caché d'un texte."
            }
          ]
        }
      ]
    },
    strand3: {
      name: "Composition",
      tests: [
        {
          id: "ffl3-11-test",
          title: "Test de rédaction",
          duration: "50 minutes",
          totalMarks: 35,
          questions: [
            {
              id: 1,
              question: "Nommez les trois parties principales d'une composition et expliquez brièvement le rôle de chacune.",
              marks: 6,
              answer: "1. Introduction: présente le sujet et attire l'attention\n2. Développement: développe les idées principales avec des exemples\n3. Conclusion: résume les idées et donne une opinion finale"
            },
            {
              id: 2,
              question: "Complétez avec le connecteur approprié (donc, mais, parce que, d'abord, ensuite):\n(a) Je suis fatigué ____ j'ai beaucoup travaillé.\n(b) ____ je me lève, ____ je prends mon petit-déjeuner.\n(c) Il pleut, ____ je reste à la maison.\n(d) J'aime le chocolat ____ il n'est pas bon pour la santé.",
              marks: 5,
              answer: "(a) parce que\n(b) D'abord, ensuite\n(c) donc\n(d) mais"
            },
            {
              id: 3,
              question: "Écrivez une courte lettre informelle (8-10 phrases) à un ami pour lui raconter vos dernières vacances. Incluez: où vous êtes allé(e), ce que vous avez fait, ce que vous avez aimé.",
              marks: 12,
              answer: "Réponse modèle: Cher ami,\n\nJ'espère que tu vas bien. Je t'écris pour te raconter mes vacances. Je suis allé(e) à Santo avec ma famille. Nous avons visité les trous bleus. C'était magnifique! J'ai aussi nagé dans la mer. La plage était très belle. J'ai beaucoup aimé cette expérience. J'espère te voir bientôt.\n\nAmitiés,\n[Nom]"
            },
            {
              id: 4,
              question: "Réécrivez ces phrases en utilisant des connecteurs pour les relier:\n- J'étudie beaucoup.\n- Je veux réussir mes examens.\n- Je suis fatigué(e).",
              marks: 4,
              answer: "J'étudie beaucoup parce que je veux réussir mes examens. Cependant, je suis fatigué(e). / Comme je veux réussir mes examens, j'étudie beaucoup, donc je suis fatigué(e)."
            }
          ]
        }
      ]
    },
    strand4: {
      name: "Étude de la langue",
      tests: [
        {
          id: "ffl4-11-test",
          title: "Test de grammaire",
          duration: "40 minutes",
          totalMarks: 30,
          questions: [
            {
              id: 1,
              question: "Conjuguez le verbe 'parler' au présent pour toutes les personnes.",
              marks: 6,
              answer: "je parle, tu parles, il/elle parle, nous parlons, vous parlez, ils/elles parlent"
            },
            {
              id: 2,
              question: "Mettez ces phrases au passé composé:\n(a) Je mange une pomme.\n(b) Nous allons à l'école.\n(c) Elle finit son travail.\n(d) Ils font leurs devoirs.",
              marks: 8,
              answer: "(a) J'ai mangé une pomme.\n(b) Nous sommes allé(e)s à l'école.\n(c) Elle a fini son travail.\n(d) Ils ont fait leurs devoirs."
            },
            {
              id: 3,
              question: "Mettez ces phrases au futur simple:\n(a) Je parle français.\n(b) Nous finissons à 5 heures.\n(c) Tu vas à la plage.",
              marks: 6,
              answer: "(a) Je parlerai français.\n(b) Nous finirons à 5 heures.\n(c) Tu iras à la plage."
            },
            {
              id: 4,
              question: "Identifiez la partie du discours (nom, verbe, adjectif, adverbe) pour chaque mot souligné:\n\"Le _petit_ garçon _court_ _rapidement_ vers la _maison_.\"",
              marks: 4,
              answer: "petit = adjectif, court = verbe, rapidement = adverbe, maison = nom"
            },
            {
              id: 5,
              question: "Quelle est la différence entre le passé composé et l'imparfait? Donnez un exemple pour chaque.",
              marks: 6,
              answer: "Passé composé: action terminée, ponctuelle. Ex: \"J'ai mangé à midi.\"\nImparfait: description, habitude, action en cours. Ex: \"Il faisait beau\" / \"Je mangeais tous les jours à midi.\""
            }
          ]
        }
      ]
    }
  }
};

export const year12FrenchUnitTests = {
  year: 12,
  subject: "French as a Foreign Language",
  strands: {
    strand1: {
      name: "Expression orale avancée",
      tests: [
        {
          id: "ffl1-12-test",
          title: "Test de présentation orale",
          duration: "40 minutes",
          totalMarks: 30,
          questions: [
            {
              id: 1,
              question: "Nommez les six parties d'une bonne présentation orale.",
              marks: 6,
              answer: "1. Accroche\n2. Introduction\n3. Plan\n4. Développement\n5. Conclusion\n6. Questions"
            },
            {
              id: 2,
              question: "Traduisez ces expressions de présentation:\n(a) \"I'm going to talk about...\"\n(b) \"My presentation is about...\"\n(c) \"To conclude...\"\n(d) \"Do you have any questions?\"",
              marks: 4,
              answer: "(a) Je vais vous parler de...\n(b) Mon exposé porte sur...\n(c) Pour conclure...\n(d) Avez-vous des questions?"
            },
            {
              id: 3,
              question: "Donnez trois conseils pour bien présenter devant un public.",
              marks: 3,
              answer: "Maintenir le contact visuel, parler clairement et pas trop vite, utiliser des gestes naturels, utiliser des supports visuels, engager l'auditoire"
            },
            {
              id: 4,
              question: "Comment peut-on réfuter poliment un argument dans un débat? Donnez deux expressions.",
              marks: 4,
              answer: "\"Je m'oppose à cette idée parce que...\"\n\"Cet argument n'est pas valable car...\"\n\"Je comprends votre point de vue, mais...\"\n\"Permettez-moi de ne pas être d'accord...\""
            },
            {
              id: 5,
              question: "Préparez un plan pour une présentation de 3 minutes sur 'Les avantages de parler français'. Écrivez les points principaux.",
              marks: 8,
              answer: "Plan modèle:\n- Introduction: Le français dans le monde\n- Point 1: Communication avec 300 millions de personnes\n- Point 2: Opportunités professionnelles\n- Point 3: Accès à la culture française\n- Conclusion: Importance pour Vanuatu"
            }
          ]
        }
      ]
    },
    strand2: {
      name: "Lecture approfondie",
      tests: [
        {
          id: "ffl2-12-test",
          title: "Test d'analyse de texte",
          duration: "50 minutes",
          totalMarks: 35,
          questions: [
            {
              id: 1,
              question: "Expliquez la différence entre:\n(a) Le sens littéral et le sens implicite\n(b) Le registre soutenu et le registre familier",
              marks: 8,
              answer: "(a) Sens littéral: ce qui est dit directement. Sens implicite: ce qui est suggéré mais pas dit.\n(b) Registre soutenu: formel, littéraire. Registre familier: informel, langage de tous les jours."
            },
            {
              id: 2,
              question: "Identifiez le registre de ces phrases (soutenu, courant, familier):\n(a) \"Je vous prie de bien vouloir accepter...\"\n(b) \"Tu peux me passer le sel?\"\n(c) \"Pourriez-vous m'indiquer le chemin?\"",
              marks: 3,
              answer: "(a) Soutenu\n(b) Familier\n(c) Courant"
            },
            {
              id: 3,
              question: "Quelles sont les étapes pour résumer un texte? Nommez-en cinq.",
              marks: 5,
              answer: "1. Lire le texte entièrement\n2. Identifier les idées principales\n3. Éliminer les détails et exemples\n4. Reformuler avec ses propres mots\n5. Vérifier que le sens est conservé"
            },
            {
              id: 4,
              question: "Lisez ce passage et identifiez: le ton, l'intention de l'auteur, et le type de texte.\n\n\"Il est absolument nécessaire d'agir maintenant pour protéger notre environnement. Les scientifiques sont unanimes: nous devons réduire nos émissions de CO2.\"",
              marks: 6,
              answer: "Ton: sérieux, urgent\nIntention: persuader le lecteur d'agir pour l'environnement\nType de texte: argumentatif"
            }
          ]
        }
      ]
    },
    strand3: {
      name: "Rédaction formelle",
      tests: [
        {
          id: "ffl3-12-test",
          title: "Test de lettres officielles",
          duration: "50 minutes",
          totalMarks: 40,
          questions: [
            {
              id: 1,
              question: "Quelle est la structure d'une lettre officielle? Nommez les six parties principales dans l'ordre.",
              marks: 6,
              answer: "1. En-tête (adresse de l'expéditeur)\n2. Lieu et date\n3. Adresse du destinataire\n4. Objet\n5. Formule d'appel et corps de la lettre\n6. Formule de politesse et signature"
            },
            {
              id: 2,
              question: "Donnez deux formules de politesse pour:\n(a) Une lettre officielle\n(b) Une lettre à un ami",
              marks: 4,
              answer: "(a) Officielle: \"Je vous prie d'agréer mes salutations distinguées.\" / \"Veuillez accepter mes respectueuses salutations.\"\n(b) Informelle: \"Amitiés\" / \"À bientôt\" / \"Bises\""
            },
            {
              id: 3,
              question: "Quelle formule d'appel utilisez-vous pour écrire à:\n(a) Un directeur dont vous ne connaissez pas le nom\n(b) Votre meilleur ami\n(c) Une femme directrice",
              marks: 3,
              answer: "(a) Madame, Monsieur,\n(b) Cher [nom] / Salut! / Coucou!\n(c) Madame la Directrice,"
            },
            {
              id: 4,
              question: "Écrivez une lettre officielle de motivation pour un emploi d'été dans un hôtel. (150-180 mots)",
              marks: 15,
              answer: "Réponse modèle avec tous les éléments requis: en-tête, date, adresse, objet, formule d'appel, présentation, motivation, compétences, disponibilité, formule de politesse, signature."
            }
          ]
        }
      ]
    },
    strand4: {
      name: "Grammaire avancée",
      tests: [
        {
          id: "ffl4-12-test",
          title: "Test de syntaxe avancée",
          duration: "45 minutes",
          totalMarks: 35,
          questions: [
            {
              id: 1,
              question: "Transformez ces phrases à la voix passive:\n(a) Le chat mange la souris.\n(b) Les élèves font les devoirs.\n(c) On a construit cette maison en 1990.",
              marks: 6,
              answer: "(a) La souris est mangée par le chat.\n(b) Les devoirs sont faits par les élèves.\n(c) Cette maison a été construite en 1990."
            },
            {
              id: 2,
              question: "Complétez avec le pronom relatif correct (qui, que, dont, où):\n(a) L'homme ____ parle est mon père.\n(b) Le livre ____ je lis est intéressant.\n(c) La fille ____ je parle est ma sœur.\n(d) La ville ____ j'habite est petite.",
              marks: 4,
              answer: "(a) qui\n(b) que\n(c) dont\n(d) où"
            },
            {
              id: 3,
              question: "Conjuguez le verbe 'avoir' au conditionnel présent pour toutes les personnes.",
              marks: 6,
              answer: "j'aurais, tu aurais, il/elle aurait, nous aurions, vous auriez, ils/elles auraient"
            },
            {
              id: 4,
              question: "Reliez ces phrases avec un pronom relatif:\n(a) J'ai un ami. Cet ami habite à Paris.\n(b) C'est le restaurant. Nous avons mangé dans ce restaurant.\n(c) Voici le livre. J'ai besoin de ce livre.",
              marks: 6,
              answer: "(a) J'ai un ami qui habite à Paris.\n(b) C'est le restaurant où nous avons mangé.\n(c) Voici le livre dont j'ai besoin."
            },
            {
              id: 5,
              question: "Quand utilise-t-on le conditionnel? Donnez trois usages avec des exemples.",
              marks: 6,
              answer: "1. Politesse: \"Je voudrais un café, s'il vous plaît.\"\n2. Hypothèse: \"Si j'avais de l'argent, je voyagerais.\"\n3. Conseil: \"Tu devrais étudier plus.\""
            }
          ]
        }
      ]
    }
  }
};

export const year13FrenchUnitTests = {
  year: 13,
  subject: "French as a Foreign Language",
  strands: {
    strand1: {
      name: "Débat et persuasion",
      tests: [
        {
          id: "ffl1-13-test",
          title: "Test d'argumentation",
          duration: "45 minutes",
          totalMarks: 35,
          questions: [
            {
              id: 1,
              question: "Quelles sont les quatre parties d'un argument bien construit?",
              marks: 4,
              answer: "1. Thèse (position principale)\n2. Arguments (raisons)\n3. Exemples (preuves)\n4. Conclusion (réaffirmation)"
            },
            {
              id: 2,
              question: "Nommez trois techniques de persuasion et expliquez brièvement chacune.",
              marks: 6,
              answer: "1. Appel à la logique: utiliser des faits et statistiques\n2. Appel aux émotions: toucher le cœur de l'auditoire\n3. Appel à l'autorité: citer des experts\n4. Exemple personnel: partager une expérience"
            },
            {
              id: 3,
              question: "Traduisez ces expressions d'argumentation:\n(a) \"It is undeniable that...\"\n(b) \"On the contrary...\"\n(c) \"In conclusion...\"\n(d) \"A major argument is that...\"",
              marks: 4,
              answer: "(a) Il est indéniable que...\n(b) Au contraire...\n(c) En définitive... / En somme...\n(d) Un argument majeur est que..."
            },
            {
              id: 4,
              question: "Préparez trois arguments pour et trois arguments contre le sujet suivant: 'Les réseaux sociaux sont-ils bénéfiques pour les jeunes?'",
              marks: 12,
              answer: "Pour:\n1. Communication avec amis/famille éloignés\n2. Accès à l'information et à l'éducation\n3. Expression créative et partage d'idées\n\nContre:\n1. Addiction et perte de temps\n2. Cyberintimidation et problèmes de santé mentale\n3. Manque de vie privée et désinformation"
            }
          ]
        }
      ]
    },
    strand2: {
      name: "Lecture critique",
      tests: [
        {
          id: "ffl2-13-test",
          title: "Test d'analyse critique",
          duration: "50 minutes",
          totalMarks: 40,
          questions: [
            {
              id: 1,
              question: "Identifiez la figure de style dans chaque phrase et nommez-la:\n(a) \"La vie est un long fleuve tranquille.\"\n(b) \"Il est fort comme un lion.\"\n(c) \"J'ai mille choses à faire.\"\n(d) \"Le vent chante dans les arbres.\"",
              marks: 8,
              answer: "(a) Métaphore (comparaison sans 'comme')\n(b) Comparaison (avec 'comme')\n(c) Hyperbole (exagération)\n(d) Personnification (qualités humaines au vent)"
            },
            {
              id: 2,
              question: "Expliquez ce qu'est l'ironie et donnez un exemple.",
              marks: 4,
              answer: "L'ironie consiste à dire le contraire de ce qu'on pense, souvent pour critiquer. Exemple: Dire \"Bravo!\" à quelqu'un qui a cassé quelque chose (ton sarcastique)."
            },
            {
              id: 3,
              question: "Nommez quatre tons différents qu'un auteur peut utiliser et donnez un exemple de contexte pour chacun.",
              marks: 8,
              answer: "1. Ironique: critique avec humour (article satirique)\n2. Lyrique: expressif, émotionnel (poésie d'amour)\n3. Polémique: controversé, provocateur (éditorial politique)\n4. Didactique: éducatif (manuel scolaire)"
            },
            {
              id: 4,
              question: "Comment peut-on comparer les points de vue de deux auteurs sur le même sujet? Donnez trois expressions utiles.",
              marks: 6,
              answer: "1. \"L'auteur A affirme que..., tandis que l'auteur B soutient...\"\n2. \"Contrairement à X, Y pense que...\"\n3. \"Les deux auteurs s'accordent sur... mais divergent sur...\""
            }
          ]
        }
      ]
    },
    strand3: {
      name: "Essai argumentatif",
      tests: [
        {
          id: "ffl3-13-test",
          title: "Test de dissertation",
          duration: "60 minutes",
          totalMarks: 50,
          questions: [
            {
              id: 1,
              question: "Expliquez le plan dialectique (thèse-antithèse-synthèse) et son utilité dans un essai argumentatif.",
              marks: 6,
              answer: "Le plan dialectique présente:\n- Thèse: arguments pour une position\n- Antithèse: arguments contre\n- Synthèse: vision nuancée dépassant les deux positions\nIl permet de montrer la complexité d'un sujet et d'arriver à une conclusion équilibrée."
            },
            {
              id: 2,
              question: "Qu'est-ce qu'une problématique? Comment la formuler?",
              marks: 4,
              answer: "Une problématique est la question centrale à laquelle l'essai répond. Elle se formule souvent sous forme de question qui montre la tension ou le débat dans le sujet. Exemple: \"Dans quelle mesure...?\" ou \"Est-il vrai que...?\""
            },
            {
              id: 3,
              question: "Donnez trois expressions pour passer de la thèse à l'antithèse.",
              marks: 3,
              answer: "\"Cependant, on peut objecter que...\"\n\"Néanmoins, certains pensent que...\"\n\"Toutefois, il existe un autre point de vue...\""
            },
            {
              id: 4,
              question: "Rédigez une introduction complète (60-80 mots) pour le sujet suivant: 'La technologie améliore-t-elle notre vie quotidienne?'",
              marks: 10,
              answer: "Introduction modèle avec: accroche (fait/citation), présentation du sujet, problématique (question), annonce du plan."
            },
            {
              id: 5,
              question: "Nommez cinq pays francophones de continents différents.",
              marks: 5,
              answer: "Europe: France, Belgique, Suisse\nAfrique: Sénégal, Côte d'Ivoire, Cameroun\nAmérique: Canada (Québec), Haïti\nOcéanie: Nouvelle-Calédonie\nPacifique: Vanuatu"
            }
          ]
        }
      ]
    },
    strand4: {
      name: "Grammaire experte",
      tests: [
        {
          id: "ffl4-13-test",
          title: "Test de grammaire avancée",
          duration: "50 minutes",
          totalMarks: 40,
          questions: [
            {
              id: 1,
              question: "Conjuguez le verbe 'être' au subjonctif présent pour toutes les personnes.",
              marks: 6,
              answer: "que je sois, que tu sois, qu'il/elle soit, que nous soyons, que vous soyez, qu'ils/elles soient"
            },
            {
              id: 2,
              question: "Complétez avec l'indicatif ou le subjonctif:\n(a) Je pense qu'il ____ (être) là.\n(b) Je veux que tu ____ (venir).\n(c) Il est certain qu'elle ____ (réussir).\n(d) Je doute qu'il ____ (pouvoir) le faire.",
              marks: 4,
              answer: "(a) est (indicatif - certitude)\n(b) viennes (subjonctif - souhait)\n(c) réussira (indicatif - certitude)\n(d) puisse (subjonctif - doute)"
            },
            {
              id: 3,
              question: "Quand utilise-t-on le subjonctif? Donnez quatre cas avec des exemples.",
              marks: 8,
              answer: "1. Après souhait: \"Je veux que tu partes.\"\n2. Après doute: \"Je doute qu'il soit là.\"\n3. Après émotion: \"Je suis content qu'elle vienne.\"\n4. Après nécessité: \"Il faut que nous partions.\""
            },
            {
              id: 4,
              question: "Transformez au discours indirect:\n(a) Marie dit: \"J'ai faim.\"\n(b) Pierre a dit: \"Je viendrai demain.\"\n(c) Elle demande: \"Où vas-tu?\"",
              marks: 6,
              answer: "(a) Marie dit qu'elle a faim.\n(b) Pierre a dit qu'il viendrait le lendemain.\n(c) Elle demande où tu vas."
            },
            {
              id: 5,
              question: "Expliquez la concordance des temps au discours indirect avec un verbe introducteur au passé.",
              marks: 6,
              answer: "Quand le verbe introducteur est au passé:\n- Présent → Imparfait (\"je mange\" → \"il a dit qu'il mangeait\")\n- Passé composé → Plus-que-parfait (\"j'ai mangé\" → \"il a dit qu'il avait mangé\")\n- Futur → Conditionnel (\"je mangerai\" → \"il a dit qu'il mangerait\")"
            }
          ]
        }
      ]
    }
  }
};

export default {
  year11FrenchUnitTests,
  year12FrenchUnitTests,
  year13FrenchUnitTests
};
